// extracted by mini-css-extract-plugin
export var container = "OverviewCard-module--container--nHx9i";
export var group = "OverviewCard-module--group--QrpuE";
export var label = "OverviewCard-module--label--4b56j";
export var subGroup = "OverviewCard-module--subGroup--NHHdh";
export var value = "OverviewCard-module--value--nuXJq";